module.exports = __webpack_public_path__ + "static/src/content/silks/arcadia_queen.26b0f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/arcadia_queen.png
// module id = eL3Q
// module chunks = 0